import { useEffect } from "react";
function useScrollHighlightedIntoView(itemId, hasSearch) {
  useEffect(() => {
    if (!itemId) {
      return;
    }
    const element = document.querySelector("#" + itemId);
    if (element) {
      const parentElement = element.closest('[role="menu"');
      if (parentElement) {
        if (!isElementVisible(element, parentElement, hasSearch)) {
          element.scrollIntoView(false);
        }
      }
    }
  }, [itemId, hasSearch]);
}
const SEARCH_HEIGHT = 64;
function isElementVisible(el, holder, hasSearch) {
  const {
    top,
    bottom,
    height
  } = el.getBoundingClientRect();
  const holderRect = holder.getBoundingClientRect();
  const searchHeight = hasSearch ? SEARCH_HEIGHT : 0;
  if (top >= holderRect.bottom - height) {
    return false;
  }
  if (bottom <= holderRect.top + searchHeight + height) {
    return false;
  }
  return true;
}
export {
  useScrollHighlightedIntoView
};
//# sourceMappingURL=useScrollHighlightedIntoView.js.map
